import React, { useEffect, useState } from "react";
import { AutoSizer, List } from "react-virtualized";
import SkusThumbnail from "./SkusThumbnail";
import { Empty } from "antd";
import "react-virtualized/styles.css";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import  {
  pushSkusDetails,
} from "../../../ReduxComponents/Reducers/SkusReducer";

const SkuGroupView = ({
  groupedData,
  imageFlag,
  batchRef,
  dynamicHW,
  isDownloadOpen,
  handleDownloadList,
  toBeDownloaded,
  showHires,
  scrollToIndex,
  NumberofBatchCells,
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [scrolledIndex, setScrolledIndex] = useState("");
  const skusReducer = useSelector((state) => state.skusReducer);
  const [selectedFile, setSelectedFile] = useState(
    localStorage.getItem("skuScrollId")
  );
  useEffect(() => {
    if (selectedFile) {
      setTimeout(() => {
        const element = document.getElementById(selectedFile);
        console.log(element);
        if (element) {
          console.log("Scrolling to element:", element);
          element.scrollIntoView({ behavior: "smooth", block: "center" });
        } else {
          console.log("Element not found for id:", selectedFile);
        }
      }, 100);
    }
  }, [selectedFile, location]);
  useEffect(() => {
    if (selectedFile) {
      const index = groupedData.findIndex((group) =>
        group.data.some((file) => file._id === selectedFile)
      );
      if (index !== -1) {
        setScrolledIndex(index);
      }
    }
    console.log(scrolledIndex);
  }, [selectedFile, groupedData, location]);
  const handleCardClick = (data) => {
    localStorage.setItem("skuScrollId", data?._id);
    setSelectedFile(data?._id);
    if (isDownloadOpen) {
      handleDownloadList(data);
    } else {
      dispatch(pushSkusDetails({ scrollToIndex: scrollToIndex }));
      navigate(`${location?.pathname}?batch=${data?.batch}&id=${data?._id}`, {
        state: {
          skusReducer,
        },
      });
    }
  };
  const rowRenderer = ({ index, key, style }) => {
    return (
      <div
        key={key}
        style={{
          ...style,
          paddingLeft: "5px",
          // padding: "8px auto",
          borderBottom: "1px solid #afafaf",
        }}
      >
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "4px",
            marginTop: "5px",
          }}
          key={showHires}
        >
          {groupedData[index]?.data.map((objData, i) => (
            // <div
            //   className="single-thumbnail-folder"
            //   style={{
            //     width: dynamicHW?.width + "px",
            //     height: dynamicHW?.height + "px",
            //   }}
            //   key={key}
            // >
            <SkusThumbnail
               id={objData?._id}
              data={objData}
              key={key}
              style={style}
              fileIndex={index}
              dynamicHW={dynamicHW}
              isDownloadOpen={isDownloadOpen}
              handleDownloadList={handleDownloadList}
              selectedForDownload={toBeDownloaded}
              showHires={showHires}
              handleCardClick={handleCardClick}
              isSku={true}
            />
            // </div>
            // <img
            //   key={i}
            //   src={imageUrl}
            //   alt={`Image ${i + 1}`}
            //   style={{
            //     margin: "0 5px",
            //     ...imageCellSizeAndPositionGetter({ index, imageIndex: i }),
            //   }}
            // />
          ))}
        </div>
      </div>
    );
  };

  const imageCellSizeAndPositionGetter = ({ index, imageIndex }) => {
    const columnCount = 7;
    const rowPadding = 0;

    const imageWidth = dynamicHW?.width;
    const imageHeight = dynamicHW?.height - 12;

    const columnIndex = columnCount === 1 ? 0 : imageIndex % columnCount;
    const rowIndex = Math.floor(imageIndex / columnCount);

    const x = columnIndex * imageWidth;
    const y = rowIndex * (imageHeight + rowPadding);

    return {
      height: imageHeight,
      width: imageWidth,
      transform: `translate(${x}px, ${y}px)`,
    };
  };

  const calculateRowHeight = (rowData, containerWidth) => {
    const { index } = rowData;
    const numImages = groupedData[index]?.data.length;
    const imageHeight = dynamicHW?.height || 50;
    const rowPadding = 10;
    const imagesPerRow = Math.floor(containerWidth / dynamicHW?.width);

    const numRows = Math.ceil(numImages / imagesPerRow);
    return numRows * imageHeight;
  };

  return (
    <AutoSizer key={JSON.stringify(dynamicHW)}>
      {({ height, width }) => (
        <List
          // key={showHires}
          width={width}
          height={height}
          rowCount={groupedData?.length}
          rowHeight={(d) => calculateRowHeight(d, width)}
          rowRenderer={rowRenderer}
          cellSizeAndPositionGetter={imageCellSizeAndPositionGetter}
          noContentRenderer={() => (
            <Empty
              style={{
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "Center",
                alignItems: "center",
              }}
            />
          )}
          scrollToIndex={scrolledIndex}
        />
      )}
    </AutoSizer>
  );
};

export default SkuGroupView;
